import type { IconNode } from '../types';

/**
 * @name layout-list-move
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNyA2IDMgMiA3IiAvPgogIDxwYXRoIGQ9Ik02IDN2MTgiIC8+CiAgPHBhdGggZD0ibTIgMTcgNCA0IDQtNCIgLz4KICA8cGF0aCBkPSJNMTQgNGg3IiAvPgogIDxwYXRoIGQ9Ik0xNCA5aDciIC8+CiAgPHBhdGggZD0iTTE0IDE1aDciIC8+CiAgPHBhdGggZD0iTTE0IDIwaDciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/layout-list-move
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const layoutListMove: IconNode = [
  ['path', { d: 'M10 7 6 3 2 7', key: '1ozkjg' }],
  ['path', { d: 'M6 3v18', key: 'h4854d' }],
  ['path', { d: 'm2 17 4 4 4-4', key: '1mm42h' }],
  ['path', { d: 'M14 4h7', key: '3xa0d5' }],
  ['path', { d: 'M14 9h7', key: '1icrd9' }],
  ['path', { d: 'M14 15h7', key: '1mj8o2' }],
  ['path', { d: 'M14 20h7', key: '11slyb' }],
];

export default layoutListMove;
